var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.95 21.1h.1V7.928l-.04-.03L10.533.918l-.06-.043-.059.043L.941 7.897l-.041.03V21.1H8.478v-6.715h3.994V21.1h7.478ZM7.106 12.912h-.1V19.628H2.372V8.67l8.103-5.967 8.103 5.967v10.957h-4.634V12.912H7.106Z"
  })));
};
export default SvgHome;